import {Map, List} from 'immutable';

import {
    COUNTRY_LIST_REQUEST,
    COUNTRY_LIST_SUCCESS,
    COUNTRY_LIST_FAILURE,
    COUNTRY_READ_REQUEST,
    COUNTRY_READ_SUCCESS,
    COUNTRY_READ_FAILURE,
    COUNTRY_UPDATE_REQUEST,
    COUNTRY_UPDATE_SUCCESS,
    COUNTRY_UPDATE_FAILURE,
    COUNTRY_CREATE_REQUEST,
    COUNTRY_CREATE_SUCCESS,
    COUNTRY_CREATE_FAILURE,
    COUNTRY_DELETE_REQUEST,
    COUNTRY_DELETE_SUCCESS,
    COUNTRY_DELETE_FAILURE,
    COUNTRY_FORM_DESTROY
  } from './actions';
  import Logger from '../../../lib/Logger';
  
export default function countries(
    state=Map({
      areCountriesLoading: false
    }),
    action
  ) {
    Logger.log('debug', `[country.reducers] countries(%j, %j)`, state, action);
  
    switch(action.type) {
  
      case COUNTRY_LIST_REQUEST:
        return state.mergeDeep({
          areCountriesLoading: true
        });
  
      case COUNTRY_LIST_SUCCESS:
        return state.mergeDeep({
          areCountriesLoading: false,
          pages: {
            [action.order]: {
              [action.limit]: {
                [action.page]: null
              }
            }
          },
          total: action.total,
          lastUpdated: action.receivedAt
        }).setIn(['pages', action.order, action.limit, action.page], List(action.result));
  
      case COUNTRY_LIST_FAILURE:
        return state.mergeDeep({
          areCountriesLoading: false
        });
      case COUNTRY_READ_REQUEST:
        return state.mergeDeep({
          areCountriesLoading: true
        });
  
      case COUNTRY_READ_SUCCESS:
        return state.mergeDeep({
          areCountriesLoading: false,
          lastUpdated: action.receivedAt
        });
  
      case COUNTRY_READ_FAILURE:
        return state.mergeDeep({
          areCountriesLoading: false
        });
        case COUNTRY_UPDATE_REQUEST:
          return state.mergeDeep({
            areCountriesLoading: true,
            form: {
              isSubmitting: true,
              success: null,
              errors: null
            }
          });
    
        case COUNTRY_UPDATE_SUCCESS:
          return state.mergeDeep({
            areCountriesLoading: false,
            form: {
              isSubmitting: false,
              success: true,
              errors: null
            },
            lastUpdated: action.receivedAt
          });
    
        case COUNTRY_UPDATE_FAILURE:
          return state.mergeDeep({
            areCountriesLoading: false,
            form: {
              isSubmitting: false,
              success: false,
              errors: null
            }
          }).setIn(['form', 'errors'], action.error);
    
        case COUNTRY_CREATE_REQUEST:
          return state.mergeDeep({
            areCountriesLoading: true,
            form: {
              isSubmitting: true,
              success: null,
              errors: null
            }
          });
    
        case COUNTRY_CREATE_SUCCESS:
          return state.mergeDeep({
            areCountriesLoading: false,
            form: {
              isSubmitting: false,
              success: true,
              created_id: action.id,
              errors: null
            },
            lastUpdated: action.receivedAt
          });
    
        case COUNTRY_CREATE_FAILURE:
          return state.mergeDeep({
            areCountriesLoading: false,
            form: {
              isSubmitting: false,
              success: false,
              errors: null
            }
          }).setIn(['form', 'errors'], action.error);
    
        case COUNTRY_DELETE_REQUEST:
          return state.mergeDeep({
            areCountriesLoading: true
          });
    
        case COUNTRY_DELETE_SUCCESS:
          return state.mergeDeep({
            areCountriesLoading: false,
            lastUpdated: action.receivedAt
          });
    
        case COUNTRY_DELETE_FAILURE:
          return state.mergeDeep({
            areCountriesLoading: false
          });
    
        case COUNTRY_FORM_DESTROY:
          return state.mergeDeep({
            form: null
          }).set('form', action.form);
          
      default:
        return state;
    }
  }
  
  Logger.log('silly', `country.reducers loaded.`);